<lib-sticky-modal>
  <lib-sticky-header>
    <div class="modal-header">
      <div class="modal-title">Dashboard Update Required</div>
    </div>
  </lib-sticky-header>
  <lib-sticky-body>
    <div class="app-out-of-date-description">{{ viewModel.desc$ | async }}</div>
    <div class="app-out-of-date-auto-reloading">
      <ng-container *ngIf="(viewModel.nSecondsTillReload$ | async) === 0; else autoReloading">
        Auto-reloading...
      </ng-container>
      <ng-template #autoReloading>
        Auto-reloading in {{ viewModel.nSecondsTillReload$ | async }} {{ viewModel.timeUnits$ | async }}
      </ng-template>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <div class="flex-container flex-row flex-content-end">
      <lib-button-primary (buttonClicked)="viewModel.refreshPage()">Reload</lib-button-primary>
    </div>
  </lib-sticky-footer>
</lib-sticky-modal>
